<template>
  <div>
    <PropostaAssinante ref="addAssinante" @close="execute"></PropostaAssinante>
    <PropostaGrid
      ref="propostaGrid"
      @acoes="abrirAcoes"
      @pendencias="abrirPendencias"
      @revisao-bancaria="abrirRevisaoBancaria"
      @firmas-poderes="abrirFirmasPoderes"
      @editar="editar"
      @revisar="revisar"
    >
    </PropostaGrid>
    <PropostaAcoes ref="acoes" @close="response" />
    <PropostaPagamentoEdit ref="revisao" @close="response" />
    <PropostaPendencias ref="pendencias" @close="response" />
  </div>
</template>
<script>
import PropostaGrid from '../../../../_core/components/PropostaGrid'
import PropostaPagamentoEdit from './PropostaPagamentoEdit'
export default {
  components: {
    PropostaGrid,
    PropostaAssinante: () => import('./PropostaAssinante'),
    PropostaAcoes: () => import('./PropostaAcoes'),
    PropostaPendencias: () => import('./PropostaPendencias'),
    PropostaPagamentoEdit
  },
  methods: {
    abrirAcoes (item) {
      this.$refs.acoes.openModal(item)
    },
    abrirPendencias (item) {
      this.$refs.pendencias.openModal(item)
    },
    abrirRevisaoBancaria (item) {
      this.$refs.revisao.openModal(item)
    },
    abrirFirmasPoderes (item) {
      this.$refs.addAssinante.openModal(item)
    },
    revisar (current) {
      const th = this
      const codigo = current.Codigo
      th.$api.UI.Confirmacao('alerta', 'Tem certeza que deseja permitir a edição da proposta?',
        () => {
          th.$api.Multiplo.FindRecordProposta({ guidID: codigo }).then(function (response) {
            if (th.$api.UI.PostLoadData(response)) {
              const dto = {
                dto: {
                  CodigoProposta: response.Codigo
                },
                dtoReanalise: {
                  ...response,
                  DocumentoCliente: response.Cliente.DocumentoFederal,
                  Prazo: response.QtdeParcelasSolicitado,
                  DocumentoParceiroCorrespondente: th.$api.UI.Format.SomenteAlfanumerico(th.$empresa.documentoFederal),
                  PercJurosNegociado: response.PercJurosMensal
                }
              }
              th.$api.Multiplo.EnviarPropostaReanaliseManual(dto).then(function (responseReanalise) {
                if (th.$api.UI.PostLoadData(responseReanalise, true)) {
                  th.$api.Multiplo.FindRecordProposta({ guidID: codigo }).then(function (response) {
                    if (th.$api.UI.PostLoadData(response)) {
                      const dto = response
                      dto.ByPassSituacaoOnSave = true
                      dto.UsarJurosProposta = true
                      dto.Situacao = th.$aux.SituacaoPropostaEnum.EmDigitacao
                      th.$api.Multiplo.SaveProposta({ dto }).then(function (response) {
                        if (th.$api.UI.PostLoadData(response)) {
                          th.$refs.propostaGrid.refresh()
                        }
                      })
                    }
                  })
                }
              })
            }
          })
        },
        () => {
          th.$api.UI.ShowError(th.$getErrorMessage('operacao.cancelada.title'))
        },
        'Permitir Edição da Proposta'
      )
    },
    editar (current) {
      const th = this
      if (th.$param.EST_PRODUTOS) {
        if (th.$param.EST_PRODUTOS.flatMap(p => p.Produtos).filter(el => el).length > 0) {
          if (current) {
            th.$router.push({ path: `/propostas?codigoProposta=${current.Codigo}` })
          } else {
            th.$router.push('/propostas')
          }
        } else {
          th.$api.UI.ShowAlert('Alerta', 'Nenhum produto foi configurado para este portal. Por gentileza, contate o administrador.')
        }
      } else {
        th.$api.UI.ShowAlert('Alerta', 'O parâmetro de produto não foi configurado para este portal. Por gentileza, contate o administrador.')
      }
    },
    response (data) {
      if (data) { this.$refs.propostaGrid.refresh() }
    },
    execute (response, param) {
      if (param === 'openAction') {
        this.$refs.acoes.openModal({ Codigo: response })
      }
    }
  },
  mounted () {
    const th = this
    if (th.$route.query.model) {
      th.$refs.propostaGrid.refresh()
      th.$api.UI.Timeout.Default(() => {
        if (th.$refs.addAssinante) {
          th.$refs.addAssinante.openModal(this.$route.query.model, 'openAction')
        } else { return 10 }
      })
    }
  }
}
</script>
